import React, { useEffect } from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { SwitchBaseProps } from '@material-ui/core/internal/SwitchBase';

export interface EeCheckboxProps {
  label: string;
  name?: string;
  defaultChecked?: boolean;
  indeterminate?: boolean;
  legend?: string;
  checked?: boolean;
  disabled?: boolean;
  error?: string;
  onClick?: any;
  onFocus?: any;
  onChange?: SwitchBaseProps['onChange'];
}

export const EeCheckbox: React.FC<EeCheckboxProps> = ({
  label,
  legend,
  checked,
  disabled,
  error,
  defaultChecked,
  indeterminate,
  onClick,
  onFocus,
  name,
  onChange,
}) => {
  const [state, setState] = React.useState({});

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    setState({ ...state, checked: checked });
    if (onChange) {
      onChange(event, checked);
    }
  };

  return (
    <FormControl required error={error !== undefined} component="fieldset">
      {legend && <FormLabel component="legend">{legend}</FormLabel>}
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              disabled={disabled}
              defaultChecked={defaultChecked}
              indeterminate={indeterminate}
              onChange={handleChange}
              onClick={onClick}
              onFocus={onFocus}
              name={name}
              color="primary"
            />
          }
          label={label}
          classes={{ root: 'lens-ee-checkbox-label' }}
        />
      </FormGroup>
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  );
};
